import { PropsWithChildren } from 'react';

import { AssuredWorkload } from '@mui/icons-material';
import { Box } from '@mui/material';
import { CardDemonstration } from 'src/components/CardDemonstration';
import { If } from 'src/components/If';
import MetaTags from 'src/components/Seo/MetaTags';
import TabTemplate from 'src/components/UI/TabTemplate';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { ScrollToTop } from 'src/utils/scroll';

export function RunFIDCLayout({ children }: PropsWithChildren) {
  const { auth } = useAuthContext();

  return (
    <ScrollToTop>
      <MetaTags
        title="Run FIDC"
        description="Extraia informações dos FIDCS através de nossa ferramenta de busca, cole os dados de sua planilha excel e obtenha os links de todos os FIDCS encontrados."
      />

      <Box mt={0}>
        <TabTemplate
          title="Run FIDC"
          subtitle="Extraia informações dos FIDCS através de nossa ferramenta de busca, cole os dados de sua planilha excel e obtenha os links de todos os FIDCS encontrados."
          titleIcon={<AssuredWorkload />}
          tabContent={[]}
          tabIndex={0}
          handleChange={() => {}}
          breadcrumbs1="Run FIDC"
        />

        <If condition={!auth.isLoggedIn}>
          <CardDemonstration
            title="Run FIDC"
            subTitle="Extraia informações dos FIDCS através de nossa ferramenta de busca, cole os dados de sua planilha excel e obtenha os links de todos os FIDCS encontrados."
            labelButton="Faça login para continuar"
            url="/login?redirectUrl=/run-fidc"
          />
        </If>
        <If condition={auth.isLoggedIn}>{children}</If>
      </Box>
    </ScrollToTop>
  );
}
